import { ConsentPurpose } from "./enums/ConsentPurpose";
import { LEGAL_DOCUMENTS } from "./legal-documents";

/**
 * The document version recorded when an instructor grants a consent today. The Terms/Privacy
 * versions come straight from the published documents (legal-documents.ts) so they can never
 * drift from the text a member actually saw — bump the version on the document itself. The
 * stored consent record keeps the version it was granted under, so history stays accurate
 * across revisions.
 */
export const CURRENT_CONSENT_VERSIONS: Record<ConsentPurpose, string> = {
  [ConsentPurpose.TermsOfService]:
    LEGAL_DOCUMENTS[ConsentPurpose.TermsOfService].version,
  [ConsentPurpose.PrivacyPolicy]:
    LEGAL_DOCUMENTS[ConsentPurpose.PrivacyPolicy].version,
  [ConsentPurpose.MarketingEmail]: "1.0",
};

/** Human-readable labels for each consent purpose. */
export const CONSENT_PURPOSE_LABELS: Record<ConsentPurpose, string> = {
  [ConsentPurpose.TermsOfService]: "Terms of Service",
  [ConsentPurpose.PrivacyPolicy]: "Privacy Policy",
  [ConsentPurpose.MarketingEmail]: "Marketing email",
};

/** The purposes shown in the consent UI, in display order. */
export const CONSENT_PURPOSES: ConsentPurpose[] = [
  ConsentPurpose.TermsOfService,
  ConsentPurpose.PrivacyPolicy,
  ConsentPurpose.MarketingEmail,
];

/** Terms/privacy consent for a minor must be granted by a guardian (GDPR Art. 8). */
export const GUARDIAN_REQUIRED_PURPOSES: ConsentPurpose[] = [
  ConsentPurpose.TermsOfService,
  ConsentPurpose.PrivacyPolicy,
];
